import { render, staticRenderFns } from "./MenuPane.vue?vue&type=template&id=16cc7ddb&scoped=true&"
import script from "./MenuPane.vue?vue&type=script&lang=ts&"
export * from "./MenuPane.vue?vue&type=script&lang=ts&"
import style0 from "./MenuPane.vue?vue&type=style&index=0&id=16cc7ddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cc7ddb",
  null
  
)

export default component.exports